import moment from 'moment'
import React from 'react'
import Select from 'react-select'
import Modal from 'react-modal'
import DatePicker from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Text from 'react-text'
import * as dateLocale from 'date-fns/locale'
import {Context} from '../../../context'
import {duplicatePlan} from '../../../context/post'
import "react-datepicker/dist/react-datepicker.css"
import 'react-confirm-alert/src/react-confirm-alert.css'
import './index.styl'

class DateInput extends React.Component {
  render () {
    return (
      <div className="date-input" onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        {this.props.value}
      </div>
    )
  }
}

export default class Duplicate extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const {plan, group} = props
    const setState = this.setState.bind(this)
    this.state = {
      start: plan.start,
      end: plan.finish,
      title: plan.title,
      group: group,
      isOpen: true,
      setState
    }
  }

  render () {

    const context = this.context
    const {groups, planId} = context
    const format = date => moment(date).format('YYYY/MM/DD')
    const {setState, isOpen, start, end, group, title} = this.state

    const locale= context.languageId == 'en' ? dateLocale.enUS : dateLocale.es
    const navigateOut = () => {
     context.navigate({}, context.match.path.replace(/\/:action.*$/,''), {preserveQuery: true})
    }
    const close = () => setState({isOpen: false})

    const duplicate = async () => {
      await duplicatePlan({start, end, title, group: group.id, id: planId})
      context.setState({planUpdates: context.planUpdates + 1}, close)
    }

    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="duplicate-plan-dialog-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="duplicate-plan-dialog">
            <div className="title">
              <div className="label">
                <Text id="duplicate_plan" />
              </div>
            </div>
            <div className="content">
              <div className="plan-title">
                <label><Text id="title" /></label>
                <div className="input-title">
                  <input
                    placeholder={context.translate('write_here')}
                    type="text" value={title}
                    onChange={e => {
                      const title = e.target.value
                      setState({title})
                    }}
                  />
                </div>
              </div>
              <div className="group">
                <label>
                  <Text id="group_label" />
                </label>
                <Select
                  className="select-group"
                  classNamePrefix="select-group"
                  formatOptionLabel = {({name}) => name}
                  isSearchable = {false}
                  isClearable = {false}
                  escapeClearsValue = {true}
                  getOptionValue = {({id}) => id}
                  placeholder = {context.translate("pick_one")}
                  value = {group}
                  onChange = {group => {
                    setState({group})
                  }}
                  options = {groups}
                />
              </div>
              <div className="date">
                <label><Text id="date_label" /></label>
                <div className="inputs">
                  <div className="from">
                    <DatePicker
                    customInput={<DateInput />}
                    locale={locale}
                    selected={moment(start).toDate()}
                    minDate={moment().toDate()}
                    onChange={start => {
                      const endDate = moment(end).isAfter(start) ? end : moment(start).toDate()
                      setState({start, end: endDate})
                    }}
                    />
                  </div>
                  <div className="separator"><div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>-</div></div>
                  <div className="to">
                    <DatePicker
                    customInput={<DateInput />}
                    locale={locale}
                    selected={moment(end).toDate()}
                    minDate={moment(start).toDate()}
                    onChange={end => setState({end})}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="buttons">
              <button className="cancel" onClick={close}>
                <Text id="cancel_label" />
              </button>
              <button className="duplicate" onClick={duplicate}>
                <Text id="duplicate" />
              </button>
            </div>
          </div>
        </Modal>
    )
  }
}
